export const ToFirstCapital = (text) => {
  return text?.charAt(0)?.toUpperCase() + text?.slice(1);
};

export const DateToLocale = (date) => {
  return new Date(date) ? new Date(date).toLocaleString() : "No Date";
};

export const ToLowerCase = (text) => {
  return text?.toLowerCase();
};

export const config = {
  headers: {
    "Content-type": "application/json",
  },
};

export const ScrollTop = () => {
  window.scrollTo(0, 0);
};

export const DateToNormal = (date) => {
  return date ? new Date(date).toISOString().split("T")[0] : "N/A";
};

export const trimKey = (key) => {
  return key?.trim().toLowerCase().replace(/\s+/g, "");
};


export const formatKey = (key) => {
  return key
    .replace(/_/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .replace(/\b\w/g, (l) => l.toUpperCase());
};
export const currentUser = localStorage.getItem("userInfo")
export const token=JSON.parse(currentUser)?.data?.token


export const formatBytes = (bytes) => {
  if (!bytes || isNaN(bytes)) return "0 B";
  const sizes = ["B", "KB", "MB", "GB", "TB", "PB"];
  const i = Math.floor(Math.log(bytes) / Math.log(1024));
  const value = bytes / Math.pow(1024, i);
  return `${value.toFixed(2)} ${sizes[i]}`;
};
